import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'

import Quest from '../components/Quest'
import ReadabilityModal from '../components/quest/readability/ReadabilityModal'

import { fetchQuest, setQuestSection } from '../actions/quest'
import { confirm } from '../utils/confirm'
import { setAsyncRouteLeaveHook } from '../utils/router'
import { checkQuestSection, findActivity } from '../utils/quest'
import { unsubscribeFromAllChannelsWithPrefix } from '../utils/pusher'
import { assignableUsers } from '../selectors/users'

class QuestContainer extends Component {
  constructor(props) {
    super(props)
    this.routerWillLeave = this.routerWillLeave.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(fetchQuest(this.props.id))
    this.props.dispatch(
      setQuestSection(
        checkQuestSection(this.props.section),
        this.props.activityId,
        this.props.subsection
      )
    )
    setAsyncRouteLeaveHook(
      this.props.router,
      this.props.route,
      this.routerWillLeave
    )
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      this.props.dispatch(fetchQuest(nextProps.id))
    }

    if (
      nextProps.section !== this.props.section ||
      nextProps.activityId !== this.props.activityId
    ) {
      this.props.dispatch(
        setQuestSection(
          checkQuestSection(nextProps.section),
          nextProps.activityId
        )
      )
      if (window.oeQMQuestPusherInstance) {
        unsubscribeFromAllChannelsWithPrefix(
          window.oeQMQuestPusherInstance,
          'presence'
        )
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.section !== this.props.section ||
      prevProps.isEditingQuest !== this.props.isEditingQuest
    ) {
      window.scrollTo(0, 0)
    }
  }

  // https://www.snip2code.com/Snippet/1376044/Async-Route-Leave-Hook
  // http://www.it1me.com/it-answers?id=35275344&ttl=How+to+use+a+custom+component+with+react-router+route+transitions%3F
  routerWillLeave() {
    return new Promise((resolve, reject) => {
      if (!this.props.isEditingQuest && !this.props.isEditingComment) {
        // Quest section not being edited - resolve promise and leave
        resolve(true)
      } else {
        // Quest section being edited - ask for confirmation
        confirm('Are you sure', { intl: this.props.intl }).then(
          result => {
            // Navigate away confirmed, leave
            resolve(true)
          },
          result => {
            // Navigate away rejected, don't leave
            resolve(false)
          }
        )
      }
    })
  }

  render() {
    const {
      quest,
      isFetching,
      isFetchingCompiledQuest,
      user,
      dispatch,
      isEditingQuest,
      organization,
      isAssigning,
      isUnassigning,
      users,
      assignableUsers,
      isViewingReadabilityScoresModal,
      viewingReadableScoresSection,
      viewingReadableScoresSubsection,
      isFetchingAnalytics,
      activityId,
      isFetchingQuestData,
      activities
    } = this.props

    const bannerStyle = quest && quest.color ? '#'.concat(quest.color) : ''

    return (
      <div className="quest-container">
        {(isFetching ||
          !quest ||
          isFetchingCompiledQuest ||
          isFetchingAnalytics ||
          isFetchingQuestData) && <div className="loading"></div>}
        {!isFetching &&
          quest &&
          !isFetchingCompiledQuest &&
          !isFetchingAnalytics &&
          !isFetchingQuestData && (
            <div>
              <div
                className="banner-image-preview"
                style={{ background: bannerStyle }}
              />
              <Quest
                quest={quest}
                dispatch={dispatch}
                isEditingQuest={isEditingQuest}
                user={user}
                organization={organization}
                isAssigning={isAssigning}
                isUnassigning={isUnassigning}
                users={users}
                assignableUsers={assignableUsers}
                socket={this.props.socket}
                activities={activities}
              />
            </div>
          )}
        {isViewingReadabilityScoresModal && (
          <ReadabilityModal
            section={viewingReadableScoresSection}
            subsection={viewingReadableScoresSubsection}
            quest={quest}
            dispatch={dispatch}
            activity={activityId ? findActivity(activities, activityId) : null}
          />
        )}
      </div>
    )
  }
}

QuestContainer.propTypes = {
  dispatch: PropTypes.func,
  id: PropTypes.number.isRequired,
  params: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  quest: PropTypes.object,
  section: PropTypes.string,
  isFetchingCompiledQuest: PropTypes.bool.isRequired,
  isEditingQuest: PropTypes.bool.isRequired,
  router: PropTypes.object,
  route: PropTypes.object,
  activityId: PropTypes.number,
  subsection: PropTypes.string,
  user: PropTypes.object,
  organization: PropTypes.object,
  isAssigning: PropTypes.bool,
  isUnassigning: PropTypes.bool,
  users: PropTypes.array.isRequired,
  assignableUsers: PropTypes.array,
  viewingReadableScoresSection: PropTypes.string,
  viewingReadableScoresSubsection: PropTypes.string,
  isViewingReadabilityScoresModal: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  isFetchingAnalytics: PropTypes.bool.isRequired,
  socket: PropTypes.object.isRequired,
  isEditingComment: PropTypes.bool,
  isFetchingQuestData: PropTypes.bool.isRequired,
  activities: PropTypes.array.isRequired
}

export const mapStateToProps = (state, ownProps) => ({
  id: parseInt(ownProps.params.id),
  section: ownProps.params.section,
  quest: state.quest.item,
  isFetching: state.quest.isFetching,
  isFetchingCompiledQuest: state.quest.isFetchingCompiledQuest,
  isEditingQuest: state.quest.isEditingQuest,
  activityId: parseInt(ownProps.params.activityId) || state.quest.activityId,
  subsection: state.quest.subsection,
  user: state.user.user,
  organization: state.organization,
  isAssigning: state.quest.isAssigning,
  isUnassigning: state.quest.isUnassigning,
  users: state.users.items,
  assignableUsers: assignableUsers(state),
  viewingReadableScoresSection: state.quest.viewingReadableScoresSection,
  viewingReadableScoresSubsection: state.quest.viewingReadableScoresSubsection,
  isViewingReadabilityScoresModal: state.modal.isViewingReadabilityScoresModal,
  isFetchingAnalytics: state.quest.isFetchingAnalytics,
  isEditingComment: state.quest.isEditingComment,
  isFetchingQuestData: state.quest.isFetchingQuestData,
  activities: state.quest.activities
})

export default injectIntl(withRouter(connect(mapStateToProps)(QuestContainer)))
export { QuestContainer as QuestDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/Quest.js